export default __webpack_public_path__ + "static/N0050-fa1483e1989bbc823c6122e16c3d47a4.png";